import Keycloak from "keycloak-js";

export const keycloakConfig = new Keycloak({
  url: "https://api.staging.imigames.io/auth",
  realm: "IMI-Game-Maker",
  clientId: "imi-game-maker-web-client",
});
